import { createFeatureSelector } from '@ngrx/store';
import * as fromSelectedLot from './selected-lot.reducer';

// eslint-disable-next-line
export const selectSelectedLotState =
    createFeatureSelector<fromSelectedLot.SelectedLotState>(
        fromSelectedLot.selectedLotFeatureKey,
    );
